export default __webpack_public_path__ + "static/media/img-mindmap-connect-your-mind-new.1473a907.png";